import {
  deleteAnnotationClass,
  fetchAnnotationClasses,
  storeAnnotationClass
} from "@/api/craiyon";
import { SET_ANNOTATION_CLASS } from "@/store/modules/project";
import Vue from "vue";
import { AnnotationClass, normalize } from "@/store/helper";
import { countNumberOfAnnotationsForAnnotationClass } from "@/api/fhir";

const MODULE = "annotationClass/";
const _TOGGLE_LOADING = "TOGGLE_LOADING";
const _LOAD = "LOAD";
const _SET = "SET";
const _FIND = "FIND";
const _LIST = "LIST";
const _PERSIST = "PERSIST";
const _DELETE = "DELETE";

export const DELETE = MODULE + _DELETE;
export const PERSIST = MODULE + _PERSIST;
export const LOAD = MODULE + _LOAD;
export const LIST = MODULE + _LIST;
export const FIND = MODULE + _FIND;

const state = {
  byId: {},
  allIds: [],
  annotationClass: null,
  loading: false
};
const getters = {
  [_FIND](state) {
    return id => {
      return state.byId[id];
    };
  },
  [_LIST](state, getters) {
    return state.allIds.map(id => getters[_FIND](id)).filter(x => x);
  }
};

const mutations = {
  add: (state, item) => {
    for (let key of Object.keys(item)) {
      Vue.set(state.byId, key, item[key]);
      if (state.allIds.includes(key)) return;
      state.allIds.push(key);
    }
  },
  reset: state => {
    state.allIds = [];
    state.byId = {};
  },
  [_SET](state, annotationClass) {
    state.annotationClass = annotationClass;
  },
  [_TOGGLE_LOADING](state) {
    state.loading = !state.loading;
  },
  remove: (state, item) => {
    state.allIds = state.allIds.filter(x => +x.id !== item.id);
    delete state.byId[item.id];
  }
};

const actions = {
  async [_LOAD]({ commit, rootGetters, rootState }, paging) {
    commit(_TOGGLE_LOADING);
    const token = rootGetters.token;
    const project = rootState.project.currentProject;
    const res = await fetchAnnotationClasses(token, project.id);
    for (const e of res) {
      const flat = normalize(e, AnnotationClass);
      commit("add", flat.entities.annotationClass);

      // load number of annotations
      const numberOfAnnotations = await countNumberOfAnnotationsForAnnotationClass(
        e.id
      );
      flat.entities.annotationClass[
        flat.result
      ].numberOfAnnotations = numberOfAnnotations;
      commit("add", flat.entities.annotationClass);
    }
    commit(_TOGGLE_LOADING);
  },
  async [_PERSIST]({ commit, rootGetters, rootState }, item) {
    commit(_TOGGLE_LOADING);
    const token = rootGetters.token;
    const project = rootState.project.currentProject;
    console.log(item);
    const res = await storeAnnotationClass(token, item, project.id);
    item.id = res.id;
    const o = {};
    o[res.id] = item;
    commit("add", o);
    commit(_TOGGLE_LOADING);
  },
  async [_DELETE]({ commit, rootGetters }, item) {
    commit(_TOGGLE_LOADING);
    const token = rootGetters.token;
    await deleteAnnotationClass(token, item);
    commit("remove", item);
    commit(_TOGGLE_LOADING);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
